import { SignIn, SignUp } from "@clerk/react";

const Wrap = ({ children }) => (
  <div className="min-h-[75vh] flex items-center justify-center px-4 py-12">
    <div className="flex flex-col items-center gap-6">
      <p className="label-eyebrow text-gray-500">Store admin access</p>
      {children}
    </div>
  </div>
);

export const SignInPage = () => (
  <Wrap><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></Wrap>
);

export const SignUpPage = () => (
  <Wrap><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></Wrap>
);
